export const sourceInitialState = {
    source: null,
    isLoading: true,
}